import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { authService } from '@/services/auth/authService';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Start acting as another user and hand the app over to them — the one handover both entry points
 * use (the "Run as user" page and the Users grid's "Log in as").
 *
 * An in-app transition, NOT a reload (D13b: the impersonation token is memory-only, and a reload
 * would drop it and restore the admin). Every cached query is dropped, since it holds data fetched
 * as the previous identity, and identity is re-read into the auth context before going home.
 * A refused impersonation rejects, leaving the app as it was.
 */
export function useImpersonation(): (userId: string) => Promise<void> {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { refreshAuthState } = useAuth();

  return useCallback(
    async (userId: string) => {
      await authService.impersonate(userId);
      queryClient.clear();
      refreshAuthState();
      navigate('/');
    },
    [navigate, queryClient, refreshAuthState],
  );
}
